import { notificationsSaga as notifications } from 'virtues-bootstrap';

import request from './request';

import auth from './auth';
import deviceStatuses from './deviceStatuses';
import organizations from './organizations';
import patient from './patient';
import patientEngagement from './patientEngagement';
import newReport from './newReport';
import newCardioReport from './newCardioReport';
import patientQuestionnaireResponse from './patientQuestionnaireResponse';
import practitioners from './practitioners';
import reports from './reports';
import resources from './resources';
import user from './user';
import updatePatientData from './updatePatientData';
import tachyReport from './tachyReport';
import dictionary from './dictionary';

export default [
  request,
  auth,
  deviceStatuses,
  notifications,
  organizations,
  patient,
  patientEngagement,
  patientQuestionnaireResponse,
  practitioners,
  reports,
  resources,
  newReport,
  newCardioReport,
  user,
  updatePatientData,
  tachyReport,
  dictionary,
];
